module.exports = __webpack_public_path__ + "img/BGMain.7e14e911.jpg";